import React from "react";
import "../../assets/css/common.scss";
import ClassCard from "./class-card";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import closeLogo from "../../assets/img/closeIcon.svg";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import DefaultContentIcon from "../../assets/img/defaultContent.svg";
import addIcon from "../../assets/img/addIcon.svg";
import NoClassLogo from "../../assets/img/noclasslogo.svg";
import addIt from "../../assets/img/addlogo.svg";
import { Dialog, DialogActions, Button } from "@material-ui/core";
import { CLASSES, GOOGLE_DRIVE } from "../../utils/url-builder";
import LiveClassCard from "./liveclass-card";
import { get } from "../../utils/api-authentication";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EmptyMessageComponent from "../custom-components/EmptyMessageComponent/empty-Message";
import {
  getusername,
  getUserId,
  getKneuraId,
  removeBoardInfo,
  setBoardInfo,
  setClassInfo,
  getClassInfo,
} from "../../utils/authentication-access";
import DownloadCard from "./DownloadCard";
import BaseService from "../../store/services/base.service";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import classes from "./class-component.module.css";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import MediaCard from "./MediaCard/MediaCard";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CloudIcon from "@material-ui/icons/Cloud";
import { Mixpanel } from "../../utils/mixpanel";
import notificationService, {
  NOTIFICATION_TYPE,
} from "../../store/services/notification.service";
import LayoutDashboard from "../Layout_Dashboard/Layout_Dashboard";
import LessonCard from "./LessonCard/LessonCard";
import ContentBlueIcon from "../../assets/img/myContentBlueIcon.svg";
import ContentGreyIcon from "../../assets/img/myContentGreyIcon.svg";
import LessonBlueIcon from "../../assets/img/myLessonBlueIcon.svg";
import LessonGreyIcon from "../../assets/img/myLessonGreyIcon.svg";
import IframeViewer from "../IframeViewer/IframeViewer";

import { withTranslation } from "react-i18next";

class Class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      mediaData: [],
      boards: [],
      initialboards: [],
      searchText: "",
      file: [],
      sortButtonToggle: false,
      sortButtonLabel: "Last Modified",
      sortData: [],
      loader: false,
      tabStatus: "LESSONS",
      viewerDialogToggle: false,
      selectedMediaCard: {},
    };
  }

  handleLiveClassStatusChange = () => {
    setTimeout(() => {
      this.getAllBoard();
      this.sortMenuClickedHandler("Last Modified");
    }, 5000);
  };

  async componentDidMount() {
    document.title = this.props.title;
    this.getAllBoard();
    this.sortMenuClickedHandler("Last Modified");
    if (getClassInfo()) {
      await this.fetchGoogleDriveData();
    }
    notificationService.register(
      [NOTIFICATION_TYPE.START_LIVE, NOTIFICATION_TYPE.END_LIVE],
      this.handleLiveClassStatusChange,
    );
  }

  getAllBoard = async () => {
    if (getClassInfo()) {
      const class_id = getClassInfo().kneuraId;
      this.setState({ loader: true });
      let url = CLASSES.fetchClass(class_id);

      let res = await new BaseService().makeGetRequestGeneric(url);
      let boards = [];
      let initialboards = [];
      if (res.data.iwbMetaData) {
        boards = res.data.iwbMetaData.filter((board) => board.isPublic);
        initialboards = boards;
      }
      this.setState({ boards });

      this.setState({ initialboards });
      this.setState({ file: res.data.docs });
      this.setState({ loader: false });
    }
  };

  onEnterSearchText = (data) => {
    this.setState({ searchText: data });
    let updatedList = this.state.initialboards;
    updatedList = updatedList.filter(function (item) {
      return item.name.toLowerCase().indexOf(data.toLowerCase()) !== -1;
    });
    this.setState({ boards: updatedList });
  };

  sortButtonClickHandler = (event) => {
    this.setState({
      sortButtonToggle: !this.state.sortButtonToggle,
      sortButtonTarget: event.target,
    });
  };
  sortMenuClickedHandler = (item) => (event) => {
    this.setState({ sortButtonLabel: item, sortButtonToggle: false });
    if (item == "Name") {
      this.sortBoardsByName();
    } else if (item == "Last Modified") {
      this.sortBoards();
    } else if (item == "Date Created") {
      this.sortBoardsByDate();
    }
  };

  sortBoards = () => {
    let updatedList = this.state.initialboards;
    updatedList = updatedList.sort(function (a, b) {
      if (a.updatedAt < b.updatedAt) {
        return 1;
      }
      if (a.updatedAt > b.updatedAt) {
        return -1;
      }
      return 0;
    });
    this.setState({ boards: updatedList });
  };

  sortBoardsByName = () => {
    let updatedList = this.state.initialboards;
    updatedList = updatedList.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    this.setState({ boards: updatedList });
  };

  sortBoardsByDate = () => {
    let updatedList = this.state.initialboards;
    updatedList = updatedList.sort(function (a, b) {
      if (a.createdAt < b.createdAt) {
        return 1;
      }
      if (a.createdAt > b.createdAt) {
        return -1;
      }
      return 0;
    });
    this.setState({ boards: updatedList });
  };

  fetchGoogleDriveData = async () => {
    // Class Info
    const classInfo = JSON.parse(sessionStorage.getItem("classinfo"));
    // Fetch Files
    // GOOGLE DRIVE FILES
    const getGoogleDriveParamsData = {
      instituteId: localStorage.getItem("instituteKneuraId"),
      classId: classInfo.kneuraId,
    };
    const getGoogleDriveParams = Object.keys(getGoogleDriveParamsData)
      .map((item) =>
        [item, getGoogleDriveParamsData[item]]
          .map(encodeURIComponent)
          .join("="),
      )
      .join("&");
    const getGoogleDriveDataUrl =
      GOOGLE_DRIVE.fetch() + "?" + getGoogleDriveParams;
    const getGoogleDriveResponse = await new BaseService().makeGetRequestGeneric(
      getGoogleDriveDataUrl,
    );
    let getGoogleDriveResponseData = [];

    getGoogleDriveResponse.myFiles.forEach((file) => {
      console.log("file", file.type);
      // PDF PPT DOC XLS IMAGE VIDEO
      let fileIconType = "";
      switch (file.type) {
        case "image/jpeg":
        case "image/png":
          fileIconType = "IMAGE";
          break;
        case "video/mp4":
        case "audio/mp4":
        case "application/mp4":
        case "audio/webm":
        case "video/webm":
        case "video/mpeg":
        case "video/x-flv":
        case "application/x-mpegURL":
        case "video/MP2T":
        case "video/3gpp":
        case "video/quicktime":
        case "video/x-msvideo":
        case " video/x-ms-wmv":
          fileIconType = "VIDEO";
          break;
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
        case "application/vnd.ms-excel.sheet.macroEnabled.12":
        case "application/vnd.ms-excel.template.macroEnabled.12":
        case "application/vnd.ms-excel.addin.macroEnabled.12":
        case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
          fileIconType = "XLS";
          break;
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
        case "application/vnd.ms-word.document.macroEnabled.12":
        case "application/vnd.ms-word.template.macroEnabled.12":
          fileIconType = "DOC";
          break;
        case "application/vnd.ms-powerpoint":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        case "application/vnd.openxmlformats-officedocument.presentationml.template":
        case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
        case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
        case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
        case "application/vnd.ms-powerpoint.template.macroEnabled.12":
        case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
          fileIconType = "PPT";
          break;
        case "application/pdf":
          fileIconType = "PDF";
          break;
        default:
          fileIconType = "IMAGE";
          break;
      }
      if (file.isPublished) {
        getGoogleDriveResponseData.push({
          ...file,
          fileIconType: fileIconType,
        });
      }
    });
    this.setState((prevProps) => ({
      ...prevProps,
      mediaData: [...getGoogleDriveResponseData],
    }));
  };

  onTabButtonClick = (tabType) => (event) => {
    this.setState((prevProps) => ({ ...prevProps, tabStatus: tabType }));
    if (tabType == "LESSONS") {
      Mixpanel.track("My Lesson Tab Clicked");
    } else if (tabType == "MEDIA") {
      Mixpanel.track("My Content Tab Clicked");
    }
  };

  viewerDialogClose = () => {
    this.setState((prevProps) => ({ viewerDialogToggle: false }));
  };
  viewerDialogOpen = () => {
    this.setState((prevProps) => ({ viewerDialogToggle: true }));
  };

  onClickMediaCard = (mediaInfo) => {
    const viewMediaUrl =
      "https://docs.google.com/viewer?url=" +
      encodeURIComponent(mediaInfo.url) +
      "&pid=explorer&efh=false&a=v&chrome=false&embedded=true";
    const newMediaInfo = { ...mediaInfo, viewerUrl: viewMediaUrl };
    this.setState(
      (prevProps) => ({ ...prevProps, selectedMediaCard: { ...newMediaInfo } }),
      () => {
        this.viewerDialogOpen();
      },
    );
    Mixpanel.track("View Media Content");
  };

  render() {
    const { t } = this.props;
    // LESSONS PLAN BODY RENDER

    // MEDIA BODY RENDER

    const renderMedia = (
      <div
        // className="whiteboard-item"
        style={{ height: "100%" }}
      >
        <div className="classcards-grid">
          <div className="SortBoards">
            <div className="sorttitle">
            <div style={{ padding: '2vh 2vw'}}>My Content</div> 
                    </div>
          </div>
          {/* Render FIles here */}
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "scroll",
            }}
          >
            {this.state.mediaData.length === 0 ? (
              <div className="DefaultContentIcon">
                <EmptyMessageComponent text={t("No Media & Docs Found")} />
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateRows: "repeat(auto-fill, minmax(160px, 180px))",
                  gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                  gridGap: "2vh 1vw",
                  width: "100%",
                  height: "100%",
                  boxSizing: "border-box",
                  padding: "2vh 2vw",
                }}
              >
                {this.state.mediaData.map((mediaData) => (
                  <MediaCard
                    selectedMedia={(info) => {
                      this.onClickMediaCard(info);
                    }}
                    mediaDocInfo={mediaData}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );

    let renderBody = "";
    switch (this.state.tabStatus) {
      case "MEDIA":
        renderBody = renderMedia;
        break;
      default:
        renderBody = renderMedia;
    }
   let renderViewerBody = "";
    if (
      this.state.selectedMediaCard &&
      this.state.selectedMediaCard.fileIconType
    ) {
      switch (this.state.selectedMediaCard.fileIconType) {
        case "IMAGE":
          renderViewerBody = (
            <img
              style={{ width: "100vw", height: "90vh", objectFit: "contain" }}
              src={
                this.state.selectedMediaCard && this.state.selectedMediaCard.url
              }
              alt="image"
            />
          );
          break;
        case "VIDEO":
          renderViewerBody = (
            <video
              controls
              style={{ width: "100vw", height: "90vh", objectFit: "contain" }}
              src={
                this.state.selectedMediaCard && this.state.selectedMediaCard.url
              }
              alt="image"
            />
          );
          break;
        default:
          renderViewerBody = (
            <IframeViewer
              url={
                this.state.selectedMediaCard &&
                this.state.selectedMediaCard.viewerUrl
              }
            />
          );
          break;
      }
    }
    return (
      <>
        <LayoutDashboard
          classname={this.props.classname}
          breadCrumb={["Content"]}
          openClassesDrawer={this.props.openClassSideBar}
          searchTextField={true}
          searchData={(data) => {
            this.onEnterSearchText(data);
          }}
        >
          <Paper
            style={{ width: "100%", height: "100%", boxSizing: "border-box" }}
            elevation={0}
          >
            {renderBody}
          </Paper>
        </LayoutDashboard>
        {/* Media & Doc Viewer */}
        <Dialog
          fullScreen
          open={this.state.viewerDialogToggle}
          onClose={this.viewerDialogClose}
          // TransitionComponent={Transition}
        >
          <AppBar
            style={{
              position: "sticky",
              background: "rgba(0, 116, 228, 0.25)",
            }}
          >
            <Toolbar>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <IconButton
                    // edge="start"
                    // color="inherit"
                    style={{ color: "rgba(52, 73, 94, 0.75)" }}
                    onClick={this.viewerDialogClose}
                    // aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography
                    // variant="h6"
                    // className={classes.title}
                    style={{ color: "rgba(52, 73, 94, 0.75)" }}
                  >
                    {this.state.selectedMediaCard &&
                      this.state.selectedMediaCard.name}
                  </Typography>
                </div>
              </div>
            </Toolbar>
          </AppBar>
        {renderViewerBody}
        </Dialog>
      </>
    );
  }
}

export default withTranslation()(Class);
